import { useEffect, useState } from 'react';

const useDebounce = <T>(value: T, delay = 500): T => {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => setDebounced(value), delay);
        return (): void => clearTimeout(handler);
    }, [value, delay]);

    return debounced;
};

export default useDebounce;
